import { Component } from "@angular/core";

@Component({
  selector: "app-snack-bar",
  templateUrl: "./snack-bar.component.html",
  styleUrls: ["./snack-bar.component.scss"],
  standalone: false,
})
export class SnackBarComponent {
  constructor() {}
}
